<template>
  <div class="map_header">
    <ul class="map_Navigation">
      <li v-for="(x,i) in right_Navigation_data" :key="i">
        <a v-if="x.outUrl" @click="open(x.path)">{{x.name}}</a>
        <span v-else-if="!x.open&&i===0" @click="$router.push(x.path)">{{x.name}}</span>
        <span
          v-else-if="!x.open"
          @mouseenter="right_Navigation_data[i].show=true"
          @mouseleave="right_Navigation_data[i].show=false">{{x.name}}</span>
        <a v-else @click="$router.push(x.path)">{{x.name}}</a>
        <div v-if="x.show" class="er_wei_ma">
          <div>
            <img :src="x.path">
            <p v-html="x.title"></p>
          </div>
          <div v-if="x.path2" style="margin-left:20px;">
            <img :src="x.path2">
            <p v-html="x.title2"></p>
          </div>
        </div>
      </li>
      <li><span @click="userloginout()">退出</span></li>
    </ul>
    <h4 class="map_title" v-cloak>{{systemName}}</h4>
    <ul class="map_option">
      <li v-for="(x,i) of option_data" :key="x.id" @mouseleave="option_data[i].show=false">
        <span v-if="x.open_a==='button'" @click="isShowCurtain=true">{{x.name}}</span>
        <!-- <a v-else-if="x.open_a===true" :href="x.data">{{x.name}}</a> -->
        <a v-else-if="x.outUrl" @click="open(x.url)">{{x.name}}</a>
        <span v-else-if="typeof x.data==='object'" @mousemove="option_data[i].show=true">{{x.name}}</span>
        <span v-else @click="navTo(x.url)">{{x.name}}</span>
        <div v-if="x.show" class="_div">
          <p v-for="(x2,i2) of x.data" :key="i2">
            <!-- <a class="nav_a" :href="x2.url">{{x2.name}}</a> -->
            <a class="nav_a" @click="navTo(x2.url)">{{x2.name}}</a>
            <i v-if="i<x.data.length-1"></i>
          </p>
        </div>
      </li>
    </ul>
    <div class="curtain center" v-if="isShowCurtain">
      <!-- <div class="curtain-bg transition" :class="{'curtain-bg-ac':isStartAnimation}"></div> -->
      <div class="curtain-bg" v-show="isStartAnimation"></div>
      <div class="curtain-fixed center"></div>
      <div class="curtain-move">
        <div class="curtain-item curtain-left transition" :class="{'curtain-item-ac':isStartAnimation}"></div>
        <div class="curtain-item curtain-right transition" :class="{'curtain-item-ac':isStartAnimation}"></div>
      </div>
      <div class="curtain-text center">
        <p class="curtain-text-item transition" :class="{'curtain-text-ac':isStartAnimation}" style="width: 550px;font-size: 100px;letter-spacing: 2rem;">热烈祝贺</p>
        <p class="curtain-text-item transition" :class="{'curtain-text-ac':isStartAnimation}" style="width: 1460px">码上-3G48-AI智慧大数据云视频平台开通</p>
        <p class="curtain-text-item transition" :class="{'curtain-text-ac':isStartAnimation}" style="width: 1200px">成竞律师远程视频法律服务超市开业</p>
      </div>
      <div class="curtain-firework center" v-if="isStartAnimation">
        <firework :time="30000"></firework>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import firework from '@/components/firework/index'
import mixins from '@/Mixins'
export default {
  name: 'map_header',
  components: { firework },
  mixins: [ mixins ],
  props: ['data_type'],
  data() {
    return {
      systemName: '',
      right_Navigation_data: [
        // {name:'登录',path:'http://www.3g48.com/Login.aspx',show:false,open:true,title:''},
        {name:'PC端下载',path:'https://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/JCGF_for_Windows_V3.38.2.1.exe',show:false,outUrl:true,title:'',},
        {name:'APP下载',path:require('@/views/showpage/images/androiddownload.png'),show:false,title:'安卓扫描二维码<br/>苹果搜索云视频',},
        {name:'码上',path:require('@/views/showpage/images/ewm_ms_ios.png'),show:false,title:'码上IOS',path2:require('@/views/showpage/images/ewm_ms_android.png'),title2:'码上Android'},
        {href:'https://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/JCGF_for_Mac_V3.37.1.21.dmg',target:'_blank',icon:'\ue786',str:'Mac端下载',},
        {name:'小程序',path:require('@/views/showpage/images/ewmxcx_01.jpg'),show:false,title:'微信小程序'},
        {name:'公众号',path:require('@/views/showpage/images/ewmgzh_01.jpg'),show:false,title:'微信公众号'},
        {name:'微博',path:require('@/views/showpage/images/ewm_02.jpg'),show:false,title:'竞成微博'},
        {name:'帮助中心',path:'/articleDetail?catalog=signUp',show:false,open:true,title:''},
      ],
      option_data: [
        {url:'map3',name:'首页'},
        {url:'map2',name:'数据分析'},
        {url:'welcome',name:'系统管理'},
        {data:[
          {name:'招聘',url:'/fuwu?areaId=1&type=zhaopin&page=1'},
          {name:'求职',url:'/fuwu?areaId=1&type=qiuzhi&page=1'}
        ],name:'就业视吧',show:false},
        {data:[
          {name:'教育',url:'/fuwu?areaId=1&type=jiaoyu&page=1'},
          {name:'培训',url:'/fuwu?areaId=1&type=peixun&page=1'}
        ],name:'在线培训',show:false},
        {data:[
          {name:'融资',url:'/fuwu?areaId=1&type=rongzi&page=1'},
          {name:'投资',url:'/fuwu?areaId=1&type=touzi&page=1'},
          {name:'招商',url:'/fuwu?areaId=1&type=zhaoshang&page=1'},
          {name:'加盟',url:'/fuwu?areaId=1&type=jiameng&page=1'},
          ],name:'创新创业',show:false},
        // {data:[
        //   {name:'求助',url:'/fuwu?areaId=1&type=lvshi&page=1'},
        //   {name:'民事',url:'http://www.3g48.com/mingshi.html?k=fdsf'},
        //   {name:'刑事',url:'http://www.3g48.com/xingshi.html'},
        //   {name:'行政',url:'http://www.3g48.com/xingzheng.html'}
        // ],name:'法律维权',show:false},
        {url:'/fuwu?areaId=1&type=lvshi&page=1',name:'法律维权'},
        {url:'/renshi',name:'人事人才'},
        {data:[
          {name:'旅游',url:'/fuwu?areaId=1&type=lvyou&page=1'},
          {name:'美食',url:'/fuwu?areaId=1&type=meishi&page=1'},
          {name:'健康',url:'/fuwu?areaId=1&type=jiankang&page=1'},
          {name:'电商',url:'/fuwu?areaId=1&type=gouwu&page=1'}
        ],name:'乡村振兴',show:false},
        {url:'http://oa.3g48.com/HD.P.login/PassWord.aspx',name:'OA系统',show:false,outUrl:true},
        {name:'欢迎',show:false,open_a:'button'},
      ],
      isShowCurtain: false, // 控制展示幕布
      isStartAnimation: false, // 控制开始动画
      isNotClicked: true, // 控制欢迎曲播放
    }
  },
  methods:{
    ...mapMutations(['logout']),
    open(url)  {
      window.open(url)
    },
    navTo(url) {
      let route = this.$route.name
      if (route !== url) {
        this.$router.push(url)
      }
    },
    //注销
    userloginout() {
      this.$confirm('是否退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api._user_cancellation().then(res => {
          if (res.data.status == 0) {
            this.logout()
            this.$router.push('/login')
          } else { this._status(res.data) }
        })
      }).catch(() => {})
    },
  },
  created() {
    let loginData = JSON.parse(localStorage.getItem('loginData'))
    if (!loginData.admin) {
      loginData.organization ? this.option_data[2].data = 'companyInfo' : this.option_data[2].data = 'userInfo'
    }
    loginData.areaId
      ? this.$api.getSystem(loginData.areaId).then(res => {
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          this.systemName = _R.title || '码上-3G48-AI智慧大数据云视频平台'

          if (_R.officialAccountImgId) {
            this.right_Navigation_data[3].path = this._img_handler(_R.officialAccountImgId)
          } else {
            this.right_Navigation_data[3].path = require('@/views/showpage/images/ewmgzh_01.jpg')
          }

        } else { this.$message.info('获取分站配置失败') }
      })
      : this.systemName = '码上-3G48-AI智慧大数据云视频平台' 
  },
  updated() {
    var curtain = document.querySelector('.curtain')
    // console.log(curtain)
    if (curtain) {
      curtain.addEventListener('click', () => {
        // console.log(this.isNotClicked)
        if (this.isNotClicked) {
          this.isNotClicked = false
          var audio = document.createElement('audio')
          // audio.autoplay = true
          audio.loop = true
          audio.src = require('@/assets/curtains/welcome.mp3')
          audio.play()
          var audio1 = document.createElement('audio')
          // audio1.autoplay = true
          // audio1.loop = true
          audio1.src = require('@/assets/curtains/explode.mp3')
          
          let timer0 = setTimeout(() => { audio1.play() }, 1400)

          let timer1 = setTimeout(() => { this.isStartAnimation = true }, 1)
          let timer2 = setTimeout(() => {
            this.isShowCurtain = false
            this.isStartAnimation = false
            this.isNotClicked = true
            audio.pause()
            audio1.pause()
            clearTimeout(timer0)
            clearTimeout(timer1)
            clearTimeout(timer2)
            // console.log(this.isNotClicked)
          }, 31000)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.curtain {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgb(0, 0, 0);
  // background: url('~@/assets/curtains/firework-bg.png') no-repeat top center;
  background-size: 100% 100%;
  z-index: 10000;
}
.transition {
  transition: all 20s linear;
  -webkit-transition: all 20s linear; /* Safari */
}
.curtain-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  background: url('~@/assets/curtains/firework-bg.png') no-repeat top center;
  // background: rgba(0, 0, 0, 0.8);
  background-size: 100% 100%;
  &-ac {
    background: rgba(0, 0, 0, 0);
  }
}
.curtain-fixed {
  width: 100%;
  height: 100%;
  background: url('~@/assets/curtains/curtain-fixed.png') no-repeat top center;
  /* background-size: cover; */
  /* background-size: contain; */
  background-size: 100% 100%;
  position: absolute;
  z-index: 10002;
}
.curtain-move {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 10001;
}
.curtain-left {
  background: url('~@/assets/curtains/curtain-left.png') no-repeat top center;
}
.curtain-right {
  background: url('~@/assets/curtains/curtain-right.png') no-repeat top center;
}
.curtain-item {
  width: 50%;
  height: 100%;
  background-size: 100% 100%;
  z-index: 10001
}
.curtain-item-ac {
  width: 5%;
}
.curtain-text {
  width: 100%;
  height: 600px;
  line-height: 200px;
  position: absolute;
  z-index: 10000;

  &-item {
    margin: 0 auto;
    text-align: center;
    font-size: 46px;
    font-weight: bold;
    font-family: '雅黑';
    letter-spacing: 0.5rem;
    -webkit-background-clip: text;
    background-image: -webkit-gradient(linear,left top,right top,from(#f00),color-stop(#ff0),color-stop(#f00),color-stop(#ff0),to(#f00));
    background-image: linear-gradient(90deg,#f00,#ff0,#f00,#ff0,#f00);
    -webkit-text-fill-color: rgba(0,0,0,0);
    z-index: 10000;
    opacity: 0;
  }
  &-ac {
    opacity: 1;
  }
}
.curtain-firework {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 9999;
}






.map_Navigation {
  text-align: right;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.map_Navigation > li {
  margin-top: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.map_Navigation > li a, .map_Navigation > li span {
  color: #1be1fe;
  padding: 0 10px;
}
a {
  color: #1be1fe;
}
.map_title {
  text-align: center;
  font-weight: normal;
  font-size: 26px;
  letter-spacing: 1px;
}
.map_option {
  text-align: center;
  padding: 20px 0;
  font-size: 18px;
}
.map_option > li {
  display: inline-block;
  padding: 0 26px;
  cursor: pointer;
}
.map_option > li > div {
  position: absolute;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  z-index: 999;
}
.map_option > li > div > p {
  padding: 0 8px;
}
.er_wei_ma{
  position: absolute;
  min-width: 140px;
  padding: 4px;
  margin-top: 20px;
  background-color: white;
  text-align: center;
  z-index: 120;
  font-size: 12px;
  color: #646464;
  display: flex;justify-content: space-between;align-items: center;
}
.er_wei_ma img{
  width: 140px;height: 140px;
}
.nav_a {
  font-size: 14px;
  width: max-content;
  text-align: left;
  margin-right: 16px;
}
._div i {
  display: block;
  width: 1px;
  height: 8px;
  background-color: #1be1fe;
}
._div i,._div a {
  display: inline-block;
  vertical-align: middle;
}
[v-cloak] {
  display: none;
}
h4 {
  height: 36px;
  text-align: center;
}
</style>